import * as types from './constants';

export const initialState = {
  summary: {
    links: null,
    clicks: null,
    sales: null,
    conversion_rate: null,
    users: null
  },
  comparison: {
    clicks: null,
    conversion_rate: null,
    gmv: null,
    links:null ,
    users: null
  }
};

const actions = {

  // Performance Summary Cards
  [types.SET_PERFORMANCE_SUMMARY_CARDS]: (state, { payload }) => {
    const data = {
      ...state,
      summary: {
        links: payload.summary.active_links,
        clicks: payload.summary.clicks,
        sales: payload.summary.gmv,
        conversion_rate: payload.summary.conversion_rate,
        users: payload.summary.users
      },
      comparison: {
        active_links: payload.comparison.comparison.active_links,
        clicks: payload.comparison.comparison.clicks,
        sales: payload.comparison.comparison.gmv,
        conversion_rate: payload.comparison.comparison.conversion_rate,
        users: payload.comparison.comparison.users
      }
    };

    return { ...data };
  },

  [types.CLEAR_PERFORMANCE_SUMMARY_CARDS]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

